import { useTranslation } from 'react-i18next';
import type { UseTranslationResponse } from 'react-i18next';

export const keyPrefix = 'top_match_event';
export const useTopMatchEventTranslation = (): UseTranslationResponse<'widgets', typeof keyPrefix> => {
  return useTranslation('widgets', { keyPrefix });
};

export const ruRu = ({
  [keyPrefix]: {
    title: 'Наибольшее совпадение',
    attributes: 'Атрибуты',
    additional_properties: 'Дополнительные свойства',
    no_data: 'Нет данных',
  },
}) as Record<string, unknown>;

export const en = ({
  [keyPrefix]: {
    title: 'Top match',
    attributes: 'Attributes',
    additional_properties: 'Additional properties',
    no_data: 'No data',
  },
}) as Record<string, unknown>;

export const esEs = ({
  [keyPrefix]: {
    title: 'Mayor coincidencia',
    attributes: 'Atributos',
    additional_properties: 'Propiedades adicionales',
    no_data: 'Sin datos',
  },
}) as Record<string, unknown>;

export const ptBr = ({
  [keyPrefix]: {
    title: 'Maior correspondencia',
    attributes: 'Atributos',
    additional_properties: 'Propriedades adicionais',
    no_data: 'Sem dados',
  },
}) as Record<string, unknown>;
